<template>
  <div class="preview-btns-layout ml-2">
    <div style="">
      <v-row align="center" justify="center" no-gutters>
        <v-col class="mb-2">
          <span id="note">Title</span>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" no-gutters>
        <v-col class="mb-5 pt-0 pb-0">
          <v-text-field
            class="input-title"
            background-color="#161d21"
            dense
            dark
            flat
            solo
            hide-details
            :placeholder="$t('enterTitle')"
            v-model="clipTitle"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" no-gutters>
        <v-col class="mb-2">
          <span id="note">Note</span>
        </v-col>
      </v-row>
      <v-row align="center" justify="center" no-gutters>
        <v-col :class="this.mtInfo ? 'mb-0 pt-0' : 'mb-7 pt-0'">
          <v-textarea
            class="input-note"
            background-color="#161d21"
            :placeholder="$t('enterNote')"
            rows="4"
            no-resize
            v-model="note"
            dense
            dark
            flat
            solo
            hide-details
          ></v-textarea>
        </v-col>
      </v-row>
    </div>

    <v-divider v-if="blob.type === 'video/webm' || blob.type === 'audio/webm'" class="mt-6 mb-2" color="#475e69" />

    <div class="mt-1" v-if="blob.type === 'video/webm' || blob.type === 'audio/webm'">
      <v-row class="row-generate" align="center" justify="center" no-gutters>
        <v-col v-if="this.duration < this.limitTime" cols="12" align="start" class="tooShortMsg mb-2">
          <span v-html="tooShortMsg1"></span>
          <span>{{ limitTime }}</span>
          <span v-html="tooShortMsg2"></span>
        </v-col>
        <v-col cols="12" align="start" :class="this.duration < this.limitTime ? 'mt-4' : ''" style="">
          <!-- <span id="note">{{ 'Generate Summary' }}</span> -->
          <v-switch
            v-model="selected"
            label="Transcript"
            value="transcript"
            color="#13ce66"
            :ripple="false"
            :disabled="isTranscriptDisabled"
          ></v-switch>
        </v-col>
        <v-col cols="12" align="start" class="" style="">
          <!-- <span id="note">{{ 'Generate Transcript' }}</span> -->
          <v-switch
            v-model="selected"
            label="Summary"
            value="summary"
            color="#13ce66"
            :ripple="false"
            :disabled="isSummaryDisabled"
            :error-messages="
              isSummaryDisabled && this.duration >= this.limitTime
                ? 'Transcription is needed to generate a summary,'
                : ''
            "
          ></v-switch>
        </v-col>
        <v-col cols="12" class="d-flex" style="justify-content: space-between">
          <v-col cols="auto" align="start" style="align-self: center; padding: 0">
            <span
              :style="
                isTranscriptDisabled
                  ? 'position: relative; color: #96a7af60; font-size: 14px; font-weight: 500; top: -2px'
                  : 'position: relative; color: #96a7af; font-size: 14px; font-weight: 500; top: -2px'
              "
            >
              Summary Template
            </span>
          </v-col>
          <v-col cols="auto" align="end" style="padding: 0">
            <v-btn
              dark
              color="rgb(22, 29, 33)"
              @click="isSummaryRegenerationDialog = true"
              class="btn-summary-template"
              elevation="0"
              :disabled="selected.indexOf('summary') < 0"
              style="border-radius: 8px; color: #ddd"
            >
              {{ selectedTemplate ? selectedTemplate : 'None' }}
            </v-btn>
          </v-col>
        </v-col>
        <summary-regeneration
          v-if="isSummaryRegenerationDialog"
          @close="isSummaryRegenerationDialog = false"
          @language="$emit('language', $event)"
          @submitTemplate="submitTemplate($event)"
          @submitTopic="$emit('submitTopic', $event)"
          :isSummaryRegenerationDialog.sync="isSummaryRegenerationDialog"
          :btnSelectLanguage="true"
          btnName="Done"
        ></summary-regeneration>
        <v-col cols="auto" align="start" class="wrap-msg-summary-emphasis mt-3">
          <span>{{ $t('msgSummaryEmphasis') }}</span>
        </v-col>
        <v-col align="end" class=""></v-col>
        <!-- <v-col cols="12" class="d-flex mt-3" style="justify-content: space-between">
          <v-col cols="auto" align="start" style="align-self: center; padding: 0">
            <span
              :style="
                isTranscriptDisabled
                  ? 'position: relative; color: #96a7af60; font-size: 14px; font-weight: 500; top: -2px'
                  : 'position: relative; color: #96a7af; font-size: 14px; font-weight: 500; top: -2px'
              "
            >
              Language
            </span>
          </v-col>
          <v-col cols="auto" align="end" style="padding: 0"> -->
        <!-- <select-language :btnName="'Done'" @language="submitLanguage"></select-language> -->
        <!-- <select-language
              :isTranscriptDisabled.sync="isTranscriptDisabled"
              :plain="false"
              :autoDetect="true"
              btnName="Done"
              basicBtnName=""
              basicBtnColor=""
              basicBtnFontColor=""
              basicBtnIcon=""
              basicBtnIconColor=""
              @language="$emit('language', $event)"
            ></select-language> -->
        <!-- </v-col>
        </v-col> -->
        <v-col align="end" class=""></v-col>
      </v-row>
      <!-- <v-row v-if="isShowCaptureThumbnail" class="row-thumbnail mt-7" align="center" justify="center" no-gutters>
        <v-col class="mt-0 pt-0">
          <span id="note">Thumbnail</span>
        </v-col>
        <v-col cols="auto" class="my-2 pt-0">
          <thumbnail-preview-dialog :thumbnail="thumbnail"></thumbnail-preview-dialog>
          <v-btn width="100" color="#31434f" @click="setThumbnail" height="35" elevation="0">Capture</v-btn>
        </v-col>
      </v-row> -->
    </div>
    <!-- <v-row v-if="isText" align="center" justify="center" no-gutters>
      <v-col class="mt-0 pt-0 pl-10 pr-10 pb-0">
        <div class="input-div">
          <el-input
            class="textClip"
            :placeholder="$t('textRecordTitle')"
            :autosize="{ minRows: 1, maxRows: 7 }"
            :maxlength="150"
            type="textarea"
            v-model="textClip"
          ></el-input>
        </div>
        <span id="text-length">({{ textClip.length }}/150)</span>
      </v-col>
    </v-row> -->

    <!-- <v-row no-gutters class="px-7 pb-8" justify="center" align="center">
      <v-col class="row-thumbnail" align="center" no-gutters>
        <v-btn block color="#96a7af" width="100" @click="$emit('discardUpload')">
          {{ $t('discard') }}
        </v-btn>
      </v-col>
      <v-col class="row-thumbnail ml-4" align="center" no-gutters>
        <v-btn
          color="#27cd8b"
          width="100"
          block
          :disabled="(textClip === null || textClip === '') && (blob === null || duration === null)"
          :loading="isClipUploadLoading || isMtCreateLoading"
          @click="postClip"
        >
          {{ $t('post') }}
        </v-btn>
      </v-col>
    </v-row> -->
  </div>
</template>

<script>
// import ThumbnailPreviewDialog from '@/views/modal/ThumbnailPreviewDialog'
// import NotificationDialog from '@/views/modal/NotificationDialog'
import Toast from '@/views/meeting/component/Toast'
import { setCreateMt } from '@/services/meetingApi'
import { mapGetters } from 'vuex'
// import SelectLanguage from '@/views/modal/SelectLanguage'
import SummaryRegeneration from '@/views/modal/SummaryRegeneration'
// import { textToThumbnail } from '@/common/common'

export default {
  name: 'PreviewDialog',
  components: {
    // ThumbnailPreviewDialog,
    // NotificationDialog,
    // SelectLanguage,
    SummaryRegeneration,
  },
  props: {
    recordType: String,
    blob: {
      type: null,
      required: true,
    },
    duration: Number,
    isClipUploadLoading: Boolean,
  },
  data() {
    return {
      clipTitle: '',
      textClip: '',
      note: '',
      videoOptions: {
        autoplay: false,
        controls: true,
        preload: 'auto',
        playsinline: true,
        aspectRatio: '16:9',
        width: 400,
        playbackRates: [2.0, 1.75, 1.5, 1.25, 1.0, 0.75, 0.5],
        html5: {
          nativeTextTracks: false,
        },
      },
      poster: '',
      blobUrl: null,
      thumbnail: '',
      blobData: null,
      isMtCreateLoading: false,
      isSummaryDisabled: false,
      isTranscriptDisabled: false,
      limitTime: 30, // 자막 생성 위한 최소 클립 시간 (초)
      selected: ['summary', 'transcript'],
      tooShortMsg1: 'Make sure your clip&#39;s over ',
      tooShortMsg2: ' seconds if you want a transcription and summary.',
      // language: null,
      isSummaryRegenerationDialog: false,
      selectedTemplate: null,
    }
  },
  created() {
    // Follow up clip 대체하는 경우 preview clip title 에 기존 title 추가
    if (
      this.currentClip &&
      this.currentClip['clipType'] &&
      this.currentClip['clipType'].indexOf('followUp') > -1 &&
      this.isReplaceFollowUp
    ) {
      this.clipTitle = this.currentClip['clipTitle']
    }
    this.$root.$refs.previewOption = this

    // Transcript, Summary 작동 여부 세팅
    try {
      const generateOptions = localStorage.getItem('generateOptions')
      const parsedGenerateOptions =
        typeof generateOptions === 'string' ? JSON.parse(generateOptions) : ['summary', 'transcript']
      this.selected = parsedGenerateOptions
    } catch (error) {
      this.selected = ['summary', 'transcript']
    }
  },
  mounted() {
    if (this.blob && this.blob !== null) {
      this.blobUrl = URL.createObjectURL(this.blob)
      // MP4 업로드 되기 전 BlobData 로 먼저 보여준다.
      this.$store.dispatch('setBlobData', {
        bolbUrl: this.bolbUrl,
        duration: this.duration,
        type: this.blob.type,
        recordType: this.recordType,
      })

      if (this.duration < this.limitTime) this.selected = []
      this.isSummaryDisabled = this.duration < this.limitTime ? true : false
      this.isTranscriptDisabled = this.duration < this.limitTime ? true : false
    }
  },
  beforeDestroy() {
    if (this.blobUrl !== null) {
      URL.revokeObjectURL(this.blobUrl)
      this.blobUrl = null
    }
  },
  methods: {
    submitTemplate(val) {
      this.selectedTemplate = val
      this.$emit('submitTemplate', val)
    },
    // submitLanguage(language) {
    //   if (language) {
    //     this.language = language
    //   }
    // },
    // customRecipientList(val) {
    //   this.$emit('customRecipientList', val)
    // },
    // chkboxPostComment(val) {
    //   this.$emit('chkboxPostComment', val)
    // },
    // chkboxWs(val) {
    //   this.$emit('chkboxWs', val)
    // },
    async postClip() {
      // Quick Record 를 분기하기 위해 currentMt 여부를 확인
      if (!this.isQuickRecord) {
        // 업로드 실행
        this.$emit('openMultipartUpload', this.recordType)
      } else {
        // Meeting 이 없을 경우 my meeting 에 새로운 미팅 생성
        try {
          this.isMtCreateLoading = true
          // My channel 에 넣어주기 위한 조회
          let myChannel = this.chList['private'].find(
            (channel) =>
              channel['chType'] === 'P' &&
              channel['chCategory'] === 'my' &&
              channel['chPermission'] === this.userInfo['userId']
          )

          console.log('myChannel', myChannel)
          console.log('this.chlist', this.chList)

          if (myChannel) this.$store.dispatch('setSelectedCh', myChannel)

          // let userName = this.userInfo['userDisplayName'] || this.userInfo['userFullName']
          // let mtTopic =
          //   userName.toLowerCase().charAt(userName.length - 1) === 's'
          //     ? `${userName}' New Meeting`
          //     : `${userName}'s New Meeting`

          let mtTopic = ''

          let createMtResult = await setCreateMt(
            this,
            myChannel['wsId'],
            mtTopic,
            [],
            'topic',
            myChannel['chType'],
            myChannel['chId'],
            myChannel['chCategory'],
            null
          )
          // this.$emit('openMultipartUpload', this.recordType)
          this.$emit('openMultipartUpload', { mtId: createMtResult['mtId'], stId: createMtResult['stId'] })

          // route payload
          let routePayload = {
            name: `ChannelMeetingShare`,
            params: {
              wsDomain: this.selectedWsInfo ? this.selectedWsInfo['wsDomain'] : this.$route.params['wsDomain'],
              mtId: createMtResult['mtId'],
            },
          }
          this.$router.push(routePayload).catch(() => {})
        } catch (error) {
          console.log('create mt error ', error)
        } finally {
          this.isMtCreateLoading = false
        }
      }
    },
    captureThumbnail(val) {
      this.thumbnail = val
      this.$emit('captureThumbnail', val)
    },
    // 캡쳐 버튼 눌렀을 경우
    setThumbnail() {
      this.$root.$refs.previewVideo.$refs.videoComponent.captureThumbnail()
      // console.log(this.$root.$refs.previewVideo.$refs.videoComponent)
      // notify(this, 'Success', this.$t('done'), 'success')

      const content = {
        component: Toast,
        props: {
          msg: this.$t('done'),
          // submsg: '',
        },
      }
      this.$toast.success(content)
    },
    stopPreview() {
      this.$store.dispatch('setIsPlayerForceStop', !this.$store.getters.isPlayerForceStop)
    },
  },
  computed: {
    ...mapGetters(['currentClip', 'isReplaceFollowUp', 'currentMt', 'userInfo', 'chList', 'isQuickRecord']),
    isText() {
      return !this.blob || this.blob === null
    },
    isShowCaptureThumbnail() {
      return (
        this.blob !== undefined &&
        this.blob !== null &&
        (this.recordType === 'screen' || this.recordType === 'face' || this.recordType === 'upload')
      )
    },
    wsInfo() {
      return this.$store.getters.selectedWsInfo
    },
    mtInfo() {
      return this.$store.getters.currentMt
    },
  },
  watch: {
    note() {
      this.$emit('clipNote', this.note)
    },
    textClip(val) {
      this.textClip = val.replace(/\n/g, '').replace(/\r/g, '')
      this.$emit('textClip', this.textClip)
    },
    clipTitle(val) {
      this.$emit('clipTitle', val)
    },
    selected(val) {
      if (val && Array.isArray(val)) {
        let options = val
        this.isSummaryDisabled = !val.includes('transcript') ? true : false
        if (!val.includes('transcript') && val.includes('summary')) options = []
        if (this.duration >= this.limitTime) localStorage.setItem('generateOptions', JSON.stringify(options))
        this.selected = options
      } else localStorage.setItem('generateOptions', null)
    },
  },
}
</script>

<style scoped>
.preview-btns-layout {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
}
span {
  color: white;
  font-weight: bold;
}
#preview {
  font-size: 20px;
}
#note {
  font-size: 14px;
  font-weight: 600;
  color: #96a7af;
}
#text-length {
  font-size: 14px;
  display: inline-block;
  width: 100%;
  text-align: right;
  transform: translate(-20px, -30px);
  font-weight: normal;
  color: #869399;
}
.share-text-div {
  background: #1a272e;
  width: 100%;
  height: 200px;
  display: inline-block;
  vertical-align: middle;
}
.el-textarea >>> .el-textarea__inner {
  background: #1a272e;
  border-color: transparent;
  color: white;
}
.textClip >>> .el-textarea__inner {
  background: #1a272e;
  text-align: center !important;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  resize: none;
}
.el-input >>> .el-input__inner {
  background: #1a272e;
  border-color: transparent;
  color: white;
}
.input-div {
  padding-top: 30px;
  padding-bottom: 30px;
  width: 100%;
  display: inline-block;
  vertical-align: middle;
  background: #1a272e;
}

.row-thumbnail >>> .v-btn * {
  font-size: 14px;
  letter-spacing: 0;
  text-transform: none;
  color: white;
  font-weight: bold;
}
.input-title >>> input,
.input-note >>> textarea {
  font-size: 14px;
  font-weight: 400;
}
button >>> span {
  font-size: 13px !important;
  font-weight: 500 !important;
}
.row-generate >>> .v-label {
  color: #96a7af;
  font-weight: 500;
  font-size: 14px;
}
.row-generate >>> .v-label--is-disabled {
  color: #96a7af60;
}
.row-generate >>> .v-input__slot {
  display: flex;
  flex-direction: row-reverse;
}
.row-generate >>> .v-input--selection-controls {
  margin-top: 3px;
}
.row-generate >>> .error--text {
  color: #66757c !important;
}
.tooShortMsg >>> span {
  font-size: 15px;
  font-weight: 500;
  color: #ccc;
}
.row-generate >>> .v-input--selection-controls__input {
}
.btn-summary-template.v-btn--disabled:disabled {
  background-color: rgba(22, 29, 33, 0.4) !important;
}
.wrap-msg-summary-emphasis {
  padding: 0;
}
.wrap-msg-summary-emphasis span {
  color: rgb(51, 160, 116);
  font-size: 13px;
  font-weight: 400;
}
</style>
